import React,{useEffect,useState} from 'react';
import {liveQuery} from 'dexie';
import {db} from '../services/db';
import {useFarm} from '../services/farmContext';
import {useRouteRecording} from '../services/RouteRecordingContext';
import {useRouteData} from '../services/useRouteData';
import type {GpsTrackPoint} from '../types';
import {RouteGeometry,FitRoute} from './RouteMap';
import {LayersControl,LayerGroup} from 'react-leaflet';
export default function RecordedRouteLayer({followingLocation=false}:{followingLocation?:boolean}){
 const state=useRouteRecording(),{activeFarmId}=useFarm(),database=db,selected=useRouteData(state?.selectedRouteId||undefined);
 const active=state?.active?.farmId===activeFarmId?state.active:undefined;
 const [activePoints,setActivePoints]=useState<GpsTrackPoint[]>([]);
 useEffect(()=>{setActivePoints([]);if(!active)return;const s=liveQuery(()=>database.gpsTrackPoints.where('routeId').equals(active.id).sortBy('ts')).subscribe(setActivePoints);return()=>s.unsubscribe();},[database,active?.id]);
 const route=state?.recording?active:selected.route?.farmId===activeFarmId?selected.route:undefined;
 const points=state?.recording?activePoints:selected.points;
 if(selected.denied||!route&&!state?.selectedRouteId)return null;
 if(route&&route.farmId!==activeFarmId)return null;
 const name=route?.name||state?.routes.find(r=>r.id===state.selectedRouteId)?.name||'Saved route';
 // Leaflet renders control labels as HTML. Route names are user-authored text.
 const label=('Route: '+name).replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]!));
 return <LayersControl.Overlay checked name={label}><LayerGroup>{route&&<><RouteGeometry route={route} points={points}/>{!state?.recording&&<FitRoute points={points} onceKey={route.id} skip={followingLocation}/>}</>}</LayerGroup></LayersControl.Overlay>;
}
